import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import Translate from '../../components/translate/Translate';
import {ChangeAccountModalController} from './ChangeAccountModal.controller';
import {TsMultiSelect} from '../../components/ts-multi-select/ts-multi-select.component';
import './ChangeAccountModal.scss';

interface ChangeAccountModalProps {
    ctrl: ChangeAccountModalController;
}

const Header = ({ctrl}: {ctrl: ChangeAccountModalController}) => {
    return (
        <h3 className='modal-title' dir={ctrl.dir}>
            <Translate text='LOGIN.VIEW.SWITCH_ACCOUNT' />
        </h3>
    );
};

const Content = observer(({ctrl}: {ctrl: ChangeAccountModalController}) => {
    if (ctrl.state.loading) {
        return (
            <p dir={ctrl.dir}>
                <Translate text='LOGIN.VIEW.LOADING' />
            </p>
        );
    }

    return (
        <div className='form-group' dir={ctrl.dir}>
            <label className='dropdown-multi-user' htmlFor='multi-user'>
                <Translate text='LOGIN.VIEW.SELECT_ACCOUNT' />
            </label>
            {ctrl.multiSelectController && <TsMultiSelect controller={ctrl.multiSelectController} />}
        </div>
    );
});

const Footer = observer(({ctrl}: {ctrl: ChangeAccountModalController}) => {
    return (
        <>
            <button type='button' className='btn btn-default margin-right-10' onClick={() => ctrl.dismiss()}>
                <Translate text='CHANGE_SETTINGS.VIEW.CANCEL' />
            </button>
            <button type='button' className='btn btn-primary' onClick={() => ctrl.submit()} disabled={!ctrl.canSubmit}>
                {ctrl.state.saving ? (
                    <span>
                        <Translate text='LOGIN.VIEW.LOADING' />
                    </span>
                ) : (
                    <span>
                        <Translate text='LOGIN.VIEW.LOGIN' />
                    </span>
                )}
            </button>
        </>
    );
});

@observer
export class ChangeAccountModal extends TechseeBaseComponent<ChangeAccountModalProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        return (
            <GenericModal
                className='modal-dialog change-account-modal'
                header={() => <Header ctrl={ctrl} />}
                content={() => <Content ctrl={ctrl} />}
                toolbar={() => <Footer ctrl={ctrl} />}
                show={ctrl.state.isVisible}
                onHideHandler={() => ctrl.dismiss()}
                closeOnEscape={true}
            />
        );
    }
}
